import BankTransactionsView from '@/bank/BankTransactionsView.vue'
import PaymentsView from '@/bank/PaymentsView.vue'
import OcrTransactionView from '@/bank/OcrTransactionView.vue'
import { PanelContent } from '@tritt/multipanel'

export const PAYMENTS: PanelContent = { componentName: 'PaymentsView', component: PaymentsView, meta: { requiresOrg: true } }

export const BANK_TRANSACTIONS: PanelContent = { componentName: 'BankTransactionsView', component: BankTransactionsView, meta: { requiresOrg: true } }

export const OCR_TRANSACTION_VIEW: PanelContent = {
    path: '/ocr-transaction/:ocrTransactionUuid',
    componentName: 'OcrTransactionView',
    component: OcrTransactionView,
    meta: { requiresOrg: true }
}


